import { CalendarCheck, Stethoscope, Building2, HeartHandshake } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: CalendarCheck,
    title: "Experiência",
    text: "Desde 2004 cuidando da saúde.",
  },
  {
    icon: Stethoscope,
    title: "Atendimento especializado",
    text: "Cuidado focado nas necessidades de cada paciente.",
  },
  {
    icon: Building2,
    title: "Estrutura profissional",
    text: "Ambiente preparado para oferecer conforto e segurança.",
  },
  {
    icon: HeartHandshake,
    title: "Cuidado humanizado",
    text: "Atendimento com atenção, respeito e acolhimento.",
  },
];

export const Differentials = () => (
  <section data-testid="differentials-section" className="relative z-10 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-2 pb-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08}>
            <div
              data-testid={`differential-card-${i + 1}`}
              className="group h-full rounded-2xl border border-cob-light/80 bg-white p-6 shadow-[0_10px_35px_-18px_rgba(6,63,50,0.18)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_45px_-20px_rgba(6,63,50,0.3)]"
            >
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-cob-light/70 text-cob-green transition-all duration-500 group-hover:bg-cob-dark group-hover:text-cob-gold group-hover:-rotate-6 group-hover:scale-110">
                <item.icon className="h-5.5 w-5.5" strokeWidth={1.7} />
              </div>
              <h3 className="mt-5 font-serif text-xl font-semibold text-cob-dark">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cob-muted">{item.text}</p>
              <span className="mt-4 block h-px w-8 bg-cob-gold/60 transition-all duration-500 group-hover:w-14" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
